//
// QueryBase.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./common/AppliedFilters";
import "./common/AllOther";
import "../common/BIRDExpression";
import "./common/rank/RankItems";
import "./common/SortItems";

var QueryBase = createModule("BIRD::QueryBase", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        appliedOthers: [1],
        sortItems: 1,
        appliedFilters: 1,
        navigationSteps: [1],
        rankItems: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default QueryBase;
